import React from 'react';
import { useAuth } from '../contexts/SimpleAuthContext';

function Login() {
  const { login } = useAuth();

  const handleLogin = () => {
    login();
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-color)' }}>
      <div className="container-centered">
        <h2 className="text-xl mb-8" style={{ letterSpacing: '3px' }}>DIVVY LOGIN</h2>
        
        <div className="mb-8">
          <label className="block text-xs mb-4" style={{ letterSpacing: '1px' }}>
            AUTHENTICATION METHOD
          </label>
        </div>
        
        <div className="mb-12">
          <p className="text-xs mb-8 opacity-75" style={{ letterSpacing: '0.5px' }}>
            CONNECT YOUR HANDCASH WALLET TO ACCESS THE DIVIDEND DISTRIBUTION SYSTEM
          </p>
        </div>
        
        <button
          onClick={handleLogin}
          className="btn-minimal mb-8"
        >
          CONNECT WITH HANDCASH
        </button>
        
        <div className="mt-8 text-xs opacity-75" style={{ letterSpacing: '0.5px' }}>
          <p>SECURE AUTHENTICATION POWERED BY HANDCASH</p>
        </div>
      </div>
    </div>
  );
}

export default Login;